import { useTranslation } from 'next-i18next';
import React, { VFC, useContext } from 'react';

import MarketplaceItemsContext from '@/contexts/MarketplaceItemsContext';
import CloseIcon from '@/icons/close-icon.svg';
import { pseudoRandom } from '@/utils/pseudoRandom';

import styles from './TagScroller.module.scss';

type Props = {
  tagName: string;
  tagNameJA: string;
  isShowingNFTs: boolean;
};

const tagSelectorColors = [
  styles.tagSelectorColor1,
  styles.tagSelectorColor2,
  styles.tagSelectorColor3,
  styles.tagSelectorColor4,
  styles.tagSelectorColor5,
];

const TagSelector: VFC<Props> = ({ tagName, tagNameJA, isShowingNFTs }) => {
  const {
    searchConditionNFTs,
    searchConditionUsers,
    setSearchConditionNFTs,
    setSearchConditionUsers,
  } = useContext(MarketplaceItemsContext);
  const { i18n } = useTranslation();

  const removeTag = () => {
    if (isShowingNFTs) {
      const prevTagNames = searchConditionNFTs.tagNames;
      const prevTagNamesJA = searchConditionNFTs.tagNamesJA;
      const newSearchConditionNFTs = {
        ...searchConditionNFTs,
        tagNames: prevTagNames.filter((value) => value !== tagName),
        tagNamesJA: prevTagNamesJA.filter((value) => value !== tagNameJA),
      };
      setSearchConditionNFTs(newSearchConditionNFTs);
    } else {
      const prevTagNames = searchConditionUsers.tagNames;
      const prevTagNamesJA = searchConditionUsers.tagNamesJA;
      const newSearchConditionUsers = {
        ...searchConditionUsers,
        tagNames: prevTagNames.filter((value) => value !== tagName),
        tagNamesJA: prevTagNamesJA.filter((value) => value !== tagNameJA),
      };
      setSearchConditionUsers(newSearchConditionUsers);
    }
  };

  return (
    <div
      className={`${styles.tagSelector} ${
        tagSelectorColors[pseudoRandom(tagName, 0, 4)]
      }`}
    >
      <span className={styles.tagName}>
        {i18n.language === 'ja' ? tagNameJA : tagName}
      </span>
      <CloseIcon className={styles.closeIcon} onClick={removeTag} />
    </div>
  );
};

export default TagSelector;
